import Layout from '@/layout';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

// 父应用自己的路由，理论上这些路由不参与权限路由
export const constantsRouters = [
    {
        path: '/',
        name: '/',
        menuName: '首页',
        component: Layout,
        redirect: '/any',
        id: 'index',
        pid: '0',
        menuType: 1,
        icon:
            'https://devdevnew-oss.aikucun.com/saas/0a714cea58334a85aa3d77e9185299c1b4d4585b_1624956034454_76.png',
        meta: {
            internal: true, // 是否是内部路由
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        children: [
            {
                path: '/any',
                name: 'any',
                menuName: '消息中心',
                id: 'any',
                pid: 'index',
                menuType: 2,
                meta: {
                    internal: true,
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                },
                component: () =>
                    import(/* webpackChunkName: 'welcome' */ '@/views/welcome')
            },
            {
                path: '/profile',
                name: 'profile',
                menuName: '个人中心',
                id: 'profile',
                pid: 'index',
                menuType: 2,
                hide: true,
                meta: {
                    internal: true,
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                },
                component: () =>
                    import(/* webpackChunkName: 'welcome' */ '@/views/profile')
            }
        ]
    }
];

const routes = [
    {
        path: '/',
        name: 'homepage',
        component: () =>
            import(/* webpackChunkName: 'homepage' */ '@/views/home')
    },
    {
        path: '/micro-app-full-screen/:anything?/*',
        name: 'microApp',
        component: () =>
            import(
                /* webpackChunkName: "micro-app" */ '@/views/micro-app-full-screen/index.vue'
            )
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import(/* webpackChunkName: "login" */ '../views/login/index.vue')
    },
    {
        path: '/freeLogin',
        name: 'freeLogin',

        component: () =>
            import(
                /* webpackChunkName: 'welcome' */ '@/views/login/free-login.vue'
            )
    },
    {
        path: '/register',
        name: 'register',
        component: () =>
            import(
                /* webpackChunkName: "register" */ '../views/register/index.vue'
            )
    },
    {
        path: '/any/:anything?/*',
        name: 'layout',
        meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        },
        component: () =>
            import(/* webpackChunkName: "layout" */ '../layout/index.vue')
    },
    ...constantsRouters,
    {
        path: '*',
        name: 'notfound',
        component: () =>
            import(/* webpackChunkName: "404" */ '../components/404.vue')
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import('../views/agreement/index.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;
